<template>
    <div class="multipleSelectAttrItem">
        <el-form-item 
            :label="attrData.attributeName" 
            label-position="top" 
            :prop="attrData.attributeId+''" 
            :key="attrData.attributeId"
        >
            <el-table
                :data="tableData"
                :highlight-current-row="true"
                style="width: 100%"
            >
                <el-table-column
                    prop="material"
                    label="材质"
                    width="500"
                    class-name="materialClass"
                >
                    <template slot-scope="{ row }">
                        <el-select 
                            v-model="row.key" 
                            placeholder="请选择" 
                            width="100%"
                            filterable
                            allow-create
                            @change="(val) => handleChange(val)"
                        >
                            <el-option
                                v-for="o in attributeList"
                                :key="o.attributeValueId"
                                :label="o.attributeValue"
                                :value="o.attributeValueId"
                                :disabled="row.key != o.attributeValueId && notSelected.includes(o.attributeValueId)"
                            >
                            </el-option>
                        </el-select>
                    </template> 
                </el-table-column>
                <el-table-column
                    prop="ratio"
                >
                    <template slot="header" slot-scope="scope">
                        <div>成分比例<span class="subtitle">所有成分比例之和需等于100%</span></div>
                    </template>
                    <template slot-scope="{ row }">
                        <el-input-digit
                            autofocus
                            v-model="row.value"
                            :precision="2"
                            autoSelect
                            :max="100"
                            style="width: 100%"
                            @blur="handleBlur"
                        />
                    </template> 
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="100"
                >
                    <template slot-scope="{ row,$index }">
                        <el-link :underline="false" @click="delCompositionRatio($index)">删除</el-link>
                    </template> 
                </el-table-column>
            </el-table>
            <el-button type="text" @click="addCompositionRatio">+添加</el-button>
        </el-form-item>
    </div>
</template>
<script>
// import { requiredValidate } from './rulesValidate.js'

export default {
  props: {
    value:{
        type:Array,
        default: () => {
            return [];
        }
    },
    formdata:  {
      type: Object,
      default: () => {
        return {};
      }
    },
    attrData:{
        type: Object,
        default: () => {
            return {};
        }
    },
    attributeList:  {
      type: Array,
      default() {
        return [];
      }
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
        tableData:[
            {
                key:'',
                value:'',
            }
        ],
    };
  },
  watch: {
    value:{
        handler(v){
            if(v && v.length > 0){
                this.tableData = v;
            }
        },
        deep: true,
        immediate: true
    }
  },
  computed: {
    // 禁止选的属性
    notSelected(){
        let list = this.tableData.filter(item => item.key).map(item => item.key)
        return list
    }
  },

  methods: {
    addCompositionRatio(){
        this.tableData.push({
            key:'',
            value:'',
        })
    },
    delCompositionRatio(index){
         this.tableData.splice(index,1)
    },
    handleChange(val){
        this.$emit('change', this.tableData);
        this.$emit('selectChange', val);
        this.$emit('valid')
    },
    handleBlur(){
        this.$emit('change', this.tableData);
        this.$emit('valid')
    }
  },
  mounted(){
  }
};
</script>

<style lang="scss" scope>
.multipleSelectAttrWrap{
    .multipleSelectAttrItem{
        margin-bottom: 15px;
        .attributes_label{
            color: #333;
            font-size: 12px;
        }
        .subtitle{
            color:#999;
            margin-left: 2px;
        }
        .error-text{
            color: red;
            font-size: 12px;
        }
    }
}
</style>